import React, { useEffect, useState, memo, useContext } from "react";
import {
    Box,
    Grid,
    Typography,
} from "@mui/material";
import quizSuccessBg from "assets/images/quizSuccessBg.png";
import quizSuccessIcon from "assets/images/quizSuccessIcon.png";
import { FaCheck } from "react-icons/fa6";
import Confetti from "react-confetti";
import { useWindowSize } from 'react-use';
import UserContext from "context/userContext/UserContext";

const QuizFeedback = ({ success }) => {
    const [quizDataSuccess, setQuizData] = useState(null);
    const { width, height } = useWindowSize();
    const { userData, isLoading } = useContext(UserContext);
    const [userInfo, setUserInfo] = useState(null);

    // List of random phrases
    const phrases = [
        "Amazing!",
        "Great Job!",
        "Fantastic!",
        "You're Awesome!",
        "Brilliant!",
        "Nice Work!",
        "Outstanding!",
    ];

    // Function to randomly select a phrase
    const getRandomPhrase = () => {
        return phrases[Math.floor(Math.random() * phrases.length)];
    };

 // Function to capitalize first letter of each word
 const capitalizeFirstLetter = (str) => {
    if (!str) return '';
    return str.split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  };
  
    useEffect(() => {
        if (success) {
            setQuizData(true);
        }
    }, [success]);

    // Effect to get user info from context
    useEffect(() => {
        if (!isLoading && userData && userData.length > 0) {
            const userObject = userData.find(
                (item) => typeof item === "object" && "user_id" in item
            );
            if (userObject && userObject !== userInfo) {
                setUserInfo(userObject);
            }
        }
    }, [userData, isLoading, userInfo]);

    // Get full name with capitalized first letters
    const fullName = userInfo 
        ? `${capitalizeFirstLetter(userInfo.first_name)} ${capitalizeFirstLetter(userInfo.last_name)}`
        : '';


    return quizDataSuccess ? (
        <Box className="SAQ_wrapper quiz_feedback"
            xs={12}
            sx={{
                backgroundImage: `url(${quizSuccessBg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: '100vh',
                paddingTop: { xs: '20%', sm: '10%', md: '5%' },
            }}
        >
            <Confetti width={width} height={height} />
            <Grid
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={2}
                sx={{
                    textAlign: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    padding: 4,
                    borderRadius: 2,
                }}
            >
                <Grid className="SAQ_wrapper__options-wrapper--option-icon-g--active" sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    animation: "scale-up 1.5s ease-in-out infinite",
                    '@keyframes scale-up': {
                        '0%, 100%': { transform: 'scale(1)' },
                        '50%': { transform: 'scale(1.2)' },
                    },
                }}> 
                    <FaCheck />
                </Grid>
                <Grid item>
                    <Typography className="quiz_feedback_title" sx={{
                        fontSize: { xs: '1.5rem', sm: '2rem' },
                        marginBottom: 2,
                    }}>
                        {getRandomPhrase()}
                    </Typography>
                    <Typography 
                        sx={{
                            fontSize: { xs: '1.2rem', sm: '1.5rem' },
                            color: '#39CCCC',
                            marginTop: 1,
                            marginBottom: 2,
                        }}
                    >
                        {fullName}
                    </Typography>
                    <Typography className="quiz_feedback_para" sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        marginTop: { xs: 2, sm: 1 },
                    }}>
                        Great job completing the quiz! Let's continue the learning
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    ) : (
        <Typography></Typography>
    );
};

export default memo(QuizFeedback);